export default {
  namespaced: true,
  state: () => ({
    tasks: [],
    loading: false,
    error: null,
  }),
  getters: {
    allTasks: state => state.tasks,
    pendingTasks: state => state.tasks.filter(t => t.status === 'pending'),
    completedTasks: state => state.tasks.filter(t => t.status === 'completed'),
    taskCount: state => state.tasks.length,
  },
  mutations: {
    setTasks(state, tasks) { state.tasks = tasks; },
    addTask(state, task) { state.tasks.push(task); },
    updateTask(state, task) {
      const index = state.tasks.findIndex(t => t.id === task.id);
      if(index !== -1) state.tasks.splice(index, 1, task);
    },
    removeTask(state, id) { state.tasks = state.tasks.filter(t => t.id !== id); },
    setLoading(state, loading) { state.loading = loading; },
    setError(state, error) { state.error = error; },
  },
  actions: {
    async fetchTasks({ commit }) {
      commit('setLoading', true);
      try {
        const data = await new Promise(resolve =>
          setTimeout(() => resolve([
            { id: 1, name: 'Harvest', status: 'pending' },
            { id: 2, name: 'Fertilize', status: 'completed' },
          ]), 500)
        );
        commit('setTasks', data);
      } catch(err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async addTaskAction({ commit }, task) {
      commit('setLoading', true);
      try {
        const newTask = { ...task, id: Date.now() };
        await new Promise(resolve => setTimeout(resolve, 300));
        commit('addTask', newTask);
      } catch(err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async updateTaskAction({ commit }, task) {
      commit('setLoading', true);
      try { await new Promise(resolve => setTimeout(resolve, 300)); commit('updateTask', task); }
      catch(err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async deleteTask({ commit }, id) {
      commit('setLoading', true);
      try { await new Promise(resolve => setTimeout(resolve, 300)); commit('removeTask', id); }
      catch(err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    toggleTaskStatus({ commit, state }, id) {
      const task = state.tasks.find(t => t.id === id);
      if(task) commit('updateTask', { ...task, status: task.status === 'pending' ? 'completed' : 'pending' });
    }
  },
};
